import { useTranslations } from 'next-intl';
import React from 'react'

export default function NotFoundassas() {
    const t = useTranslations('bupi');
    return (
        <div className='container mx-auto'>
            <h2 className="max-w-[460px]">{t('notFound')}</h2>
            <p> {t('notFoundDescription')} </p>
        </div>
    )
}
